import validator from 'validator'

import type { IdValidationStrategy } from 'modules/legal_entities/lib/types'

import { ItalyIdType } from './idType'
import validateId from './idValidator'
import validateTaxId from './taxIdValidator'

class ItalyIdValidationStrategy implements IdValidationStrategy {
  constructor(private idType: ItalyIdType, private id: string, private idLabel: string) {}
  isValid(): boolean {
    if (this.disabled()) return true

    switch (this.idType) {
      case ItalyIdType.CODICE_FISCALE:
        return validateTaxId(this.id)
      case ItalyIdType.PERMESSO_DI_SOGGIORNO:
        const regex = /^I\d{8}$/
        return regex.test(this.id)
      case ItalyIdType.PASSPORT:
        return validator.isPassportNumber(this.id, 'IT')
      case ItalyIdType.CARTA_D_IDENTITA:
        return validateId(this.id)
      default:
        return false
    }
  }
  errors(): string {
    if (!this.isValid()) {
      return `Invalid ${this.idLabel} number`
    }
    return ''
  }
  disabled(): boolean {
    return ItalyIdType.PASSPORT == this.idType
  }
}

export default ItalyIdValidationStrategy
